import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { FotaInfoComponent } from '../fota-info/fota-info.component';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';

@Component({
  selector: 'app-fota-batch-list',
  templateUrl: './fota-batch-list.component.html',
  styleUrls: ['./fota-batch-list.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    NgxPaginationModule,
    DatePipe,
    DecimalPipe,
    CommonPaginationComponent,
    CommonSearchComponent,
    IndianNumberPipe,
    FotaInfoComponent,
  ],
})
export class FotaBatchListComponent implements OnInit {
  size = 10;
  page = 1;
  totalLength = 0;
  search = '';
  listOfBatch = [];

  deviceFOTAForm: FormGroup = this.formBuilder.group({
    batchListSearch: new FormControl(''),
  });

  userPermission = [];

  deleteFota = false;
  createFota = false;
  viewFotaBatch = false;
  viewManualFota = false;

  uid = '';

  numberOfFOTAInitiatedCount = 0;

  isDownloading = false;
  // storage listener for cross-tab sync
  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };
  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setDeviceFotaForm();
    this.checkPermission();
    this.syncInitialDownloadState();
    if (this.viewFotaBatch) {
      if (this.route.snapshot.paramMap.get('uid')) {
        this.uid = this.route.snapshot.paramMap.get('uid') || '';

        sessionStorage.setItem('pageNoFOTABatchList', this.page.toString());
        sessionStorage.setItem('sizeFOTABatchList', this.size.toString());

        this.deviceFOTAForm?.get('batchListSearch')?.setValue(this.uid);

        this.search = this.deviceFOTAForm?.get('batchListSearch')?.value;
        sessionStorage.setItem('searchFOTABatchList', this.search);
      }
      this.fetchBatchList();
    }
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'FOTA Batch' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'FOTA Batch' && element.view === true) {
          this.viewFotaBatch = true;
        }
        if (element.pageName === 'FOTA Batch' && element.delete === true) {
          this.deleteFota = true;
        }
        if (element.pageName === 'FOTA Batch' && element.create === true) {
          this.createFota = true;
        }
        if (element.pageName === 'Manual FOTA' && element.view === true) {
          this.viewManualFota = true;
        }
      }
    );
  }

  setDeviceFotaForm() {
    this.deviceFOTAForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  fetchBatchList() {
    this.spinner.show();
    const batchListSearch = sessionStorage.getItem('searchFOTABatchList');
    this.deviceFOTAForm
      ?.get('batchListSearch')
      ?.setValue(batchListSearch ? batchListSearch : '');
    this.search = this.deviceFOTAForm?.get('batchListSearch')?.value;

    let page = 1;
    if (parseInt(sessionStorage.getItem('pageNoFOTABatchList') || '0')) {
      page = parseInt(sessionStorage.getItem('pageNoFOTABatchList') || '0');
    } else {
      sessionStorage.setItem('pageNoFOTABatchList', page.toString());
    }
    this.page = page;
    let size = 10;
    if (parseInt(sessionStorage.getItem('sizeFOTABatchList') || '0')) {
      size = parseInt(sessionStorage.getItem('sizeFOTABatchList') || '0');
    } else {
      sessionStorage.setItem('sizeFOTABatchList', size.toString());
    }
    this.size = size;

    this.apiMicroservice
      .fetchFotaBatchList(this.page, this.size, this.search)
      .subscribe((res) => {
        this.numberOfFOTAInitiated();
        if (res.status) {
          this.listOfBatch = res.data.batchDeviceData;
          this.totalLength = res.data.totalItems;
          this.spinner.hide();
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        } else {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar('Something went wrong');
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    sessionStorage.setItem('pageNoFOTABatchList', this.page.toString());
    this.fetchBatchList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    sessionStorage.setItem('pageNoFOTABatchList', this.page.toString());
    this.size = event;
    sessionStorage.setItem('sizeFOTABatchList', this.size.toString());
    this.fetchBatchList();
  }

  onSearch(event: string) {
    this.page = 1;
    sessionStorage.setItem('pageNoFOTABatchList', this.page.toString());
    this.search = event;
    this.deviceFOTAForm?.get('batchListSearch')?.setValue(this.search);
    sessionStorage.setItem('searchFOTABatchList', this.search);
    this.fetchBatchList();
  }

  deleteFotaBatchDetails(deviceValue: {
    _id: string;
    isDeleted: boolean;
    totalPercent: number;
    batchStatus: boolean;
  }) {
    if (
      deviceValue.isDeleted === true ||
      (deviceValue.totalPercent === 100 && deviceValue.batchStatus != false)
    ) {
      alert('Cannot Abort this batch.');
    } else {
      if (confirm('Are you sure to Abort the batch?')) {
        const abortedBy = this.apiMicroservice.decryptData(
          sessionStorage.getItem('userRefId') || ''
        );
        this.apiMicroservice
          .abortFotaBatch(deviceValue._id, abortedBy)
          .subscribe({
            next: (res) => {
              if (res.status) {
                this.apiMicroservice.openSnackbar('Batch Aborted Successfully');
                this.ngOnInit();
              }
            },
            error: (ERROR: HttpErrorResponse) => {
              this.spinner.hide();
              const example = ERROR.error.message;
              this.apiMicroservice.openSnackbar(example);
              this.ngOnInit();
            },
          });
      }
    }
  }
  downloadFotaBatchDeviceReport(id: string) {
    if (confirm('Do you want to download this batch details?')) {
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      this.apiMicroservice.downloadFotaBatchDeviceReport(id).subscribe({
        next: (res) => {
          try {
            if (res?.status && res.fileDownloadUrl) {
              // window.open(res.fileDownloadUrl, '_blank');
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.apiMicroservice.openSnackbar('File ready for download');
            } else {
              this.apiMicroservice.openSnackbar(
                res?.message || 'File URL not available'
              );
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          const example =
            ERROR.error.message ||
            'Download failed. Please contact server team.';
          this.apiMicroservice.openSnackbar(example);
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
    }
  }

  view(fotaBatchRefId: string) {
    sessionStorage.setItem('fotaBatchRefId', fotaBatchRefId);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/fota-batch-details'])
    );
    const fullUrl = window.location.origin + url;

    // Open the URL in a new tab
    window.open(fullUrl, '_blank');
  }

  numberOfFOTAInitiated() {
    this.spinner.show();
    this.apiMicroservice.numberOfFOTAInitiated().subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.numberOfFOTAInitiatedCount = res.data;
      }
    });
  }

  downloadAllFOTAInitiatedDevicesReport() {
    if (
      confirm('Do want to download Device Under Regular Bulk FOTA details?')
    ) {
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      this.apiMicroservice.downloadAllFOTAInitiatedDevicesReport().subscribe({
        next: (res) => {
          try {
            if (res?.status && res.fileDownloadUrl) {
              // window.open(res.fileDownloadUrl, '_blank');
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.apiMicroservice.openSnackbar('File ready for download');
            } else {
              this.apiMicroservice.openSnackbar(
                res?.message || 'File URL not available'
              );
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          const example =
            ERROR.error.message ||
            'Download failed. Please contact server team.';
          this.apiMicroservice.openSnackbar(example);
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
    }
  }

  getDurationTooltip(device: {
    startedAt: Date | string;
    completedAt: Date | string;
  }): string {
    const formatDate = (value: Date | string | null | undefined) => {
      if (!value) return '--';

      const date = new Date(value);
      if (isNaN(date.getTime())) return '--';

      return date.toLocaleString('en-GB', {
        timeZone: 'Asia/Kolkata',
        hour12: true,
      });
    };

    return `${formatDate(device.startedAt)} to ${formatDate(device.completedAt)}`;
  }

  createNew() {
    sessionStorage.setItem('fotaBatchRefId', 'noId');
    this.redirect('fota-batch-details');
  }

  manualFOTANew() {
    sessionStorage.setItem('fotaDeviceHistoryImei', '');
    this.redirect('manual-fota');
  }

  fotaBatchReport() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/fota-batch-report'])
    );
    const fullUrl = window.location.origin + url;

    // Open the URL in a new tab
    window.open(fullUrl, '_blank');
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
